const antdSelectFilterOption = (input, option) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
export default antdSelectFilterOption;
